import { createFileRoute, Outlet } from "@tanstack/react-router";

// TNK-167 phase C — Outlet layout for the buyer account surface. Mirrors
// the [[tanstack-route-layout-pattern]] split: shop.account.tsx is the
// outlet, shop.account.index.tsx + shop.account.{login,verify}.tsx are
// the actual content routes. Sits inside the parent /shop layout (cart
// drawer + storefront fonts) — we don't duplicate that chrome here.
export const Route = createFileRoute("/shop/account")({
  component: ShopAccountLayout,
});

function ShopAccountLayout() {
  return <Outlet />;
}
